import { motion } from "framer-motion";
import Chapter from "./Chapter";

const EASE = [0.22, 1, 0.36, 1];

export default function About() {
    return (
        <section id="nosotros" className="bg-[#F3EFE6]" data-testid="about-section">
            <div className="mx-auto max-w-[1400px] px-6 py-24 sm:px-10 sm:py-32">
                <Chapter num="02" eyebrow="Manifiesto y productora" title="Nosotros" />
                <div className="max-w-3xl">
                    {/* Bio bilingüe */}
                    <motion.div
                        initial={{ opacity: 0, y: 32 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ duration: 0.7, ease: EASE }}
                    >
                        <p className="font-mono-jf text-[10px] uppercase tracking-[0.25em] text-[#6B1D2F]">ES</p>
                        <p className="mt-3 text-base leading-relaxed text-[#2B2927] sm:text-lg" data-testid="about-bio-es">
                            Estamos dedicados exclusivamente a la producción cinematográfica. Nos apasiona descubrir,
                            desarrollar e impulsar historias diferentes dentro del panorama audiovisual mexicano. Nos
                            empuja la calidad de las propuestas cinematográficas, asociadas con el desarrollo del
                            universo único de sus autores para llevar a cabo los proyectos de una manera integral,
                            atractiva y asumible.
                        </p>
                        <p className="mt-8 font-mono-jf text-[10px] uppercase tracking-[0.25em] text-[#6B1D2F]">EN</p>
                        <p className="mt-3 text-sm leading-relaxed text-[#524E48]" data-testid="about-bio-en">
                            We are dedicated exclusively to feature film production. We are passionate about
                            discovering, developing and promoting different stories within the Mexican audiovisual
                            scene. We are driven by the quality of the cinematographic proposals, associated with the
                            development of the unique universe of their authors to carry out the projects in a
                            comprehensive, attractive and affordable way.
                        </p>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
